/* global history */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import azuresearch, { AzureSearchApiSettings, AzureSearchRequest, AzureSearchGui, AzureSearchFacetDefinition, AzureSearchSearchSettings, AzureSearchApi } from '@frontisbv/scheffer-azuresearch-searchclient';
import Vue from 'vue';
import _ from 'lodash';
import vueSlider from '../slider/sliderComponent.vue';
import helper from '../../util/helper';
import $ from 'jquery';
import { setTimeout } from 'timers';
/* eslint-enable no-unused-vars */

function init(filterElementId, searchSettings, facetSettings, rangeSliders, numRangeFacets, pageData, seoSettings)
{
    var filtersApp = new Vue({
        el: '#' + filterElementId,
        components: {
            vueSlider
        },
        data: {
            searchSettings: {},
            facetSettings: [],
            rangeFacets: {},
            numRangeFacets: 0,
            pageData: {},
            facetValueOverrides: [],
            searchText: '',
            items: [],
            facets: [],
            count: 0,
            currentPage: 1,
            tempRestorePage: 1,
            hasError: false,
            checkedFacets: [],
            initialSearch: true,
            restoreFromStorage: false,
            noResults: false,
            filtered: false,
            searchApi: null,
            localStorageName: 'schefferLocal',
            ready: false,
            seoSettings: {},
            productsBlockBounds: null,
            scrollToTopTargetId: '',
            scrollToTopPos: {},
            isScrollToTopClicked: false,
            scrollDelay: 0,
            defaultSearchRequest: {
                orderBy: 'ListPrice asc',
                page: 1,
                top: 24
            }
        },
        watch: {
            checkedFacets: function (val)
            {
                this.currentPage = 1;
                this.search()
                .then((response) =>
                {
                    this.setScrollPosition();
                    this.calculateProductsBlockBounds();

                    if (this.restoreFromStorage)
                    {
                        this.currentPage = this.tempRestorePage;
                        this.search()
                        .then((secondResponse) =>
                        {
                            this.tempRestorePage = 1;
                            this.restoreFromStorage = false;
                        })
                        .catch((secondError) => { console.error(secondError); });
                    }
                })
                .catch((error) => { console.error(error); });
            },
            restoreFromStorage: function (val)
            {
                if (!val) this.ready = true;
            }
        },
        computed: {
            maxPages: function ()
            {
                // Calculate the amount of pages
                if (this.searchSettings.searchRequest.top === 0)
                {
                    console.log('To use paging you should set the searchRequest.top value');
                    return 0;
                }
                return Math.ceil(this.count / this.searchSettings.searchRequest.top);
            },
            numPageRanges: function ()
            {
                if (this.maxPages > 0)
                {
                    let numRanges = Math.floor((this.maxPages / 3));
                    if (numRanges > 0) return numRanges;
                }
                return 1;
            },
            pageRanges: function ()
            {
                let ranges = {};
                let current = 0;
                for (let i = 0; i < this.numPageRanges; i++)
                {
                    let firstInRange = ++current;
                    let secondInRange = ++current;
                    let thirdInRange = ++current;

                    let previousRangeEnd = firstInRange <= 1 ? 1 : firstInRange - 1;
                    let nextRangeStart = thirdInRange >= this.maxPages ? this.maxPages : thirdInRange + 1;

                    if (secondInRange > this.maxPages) secondInRange = -1;
                    if (thirdInRange > this.maxPages) thirdInRange = -1;
                    if (thirdInRange < 0) nextRangeStart = -1;

                    let range = { firstInRange: firstInRange, secondInRange: secondInRange, thirdInRange: thirdInRange, previousRangeEnd: previousRangeEnd, nextRangeStart: nextRangeStart };
                    ranges[firstInRange] = range;
                    ranges[secondInRange] = range;
                    ranges[thirdInRange] = range;
                }

                // Specific deviation for the last few pages (last range), only if there is more than one range
                if (this.maxPages > 3)
                {
                    let lastRange =
                    {
                        firstInRange: this.maxPages - 2,
                        secondInRange: this.maxPages - 1,
                        thirdInRange: this.maxPages,
                        previousRangeEnd: this.maxPages - 3,
                        nextRangeStart: this.maxPages
                    };
                    ranges[(this.maxPages - 2)] = lastRange;
                    ranges[(this.maxPages - 1)] = lastRange;
                    ranges[(this.maxPages)] = lastRange;
                }
                return ranges;
            },
            currentPageRange: function ()
            {
                if (this.maxPages <= 3) return this.pageRanges[1];
                let range = this.pageRanges[this.currentPage];
                return range;
            },
            pointerEventPreviousPage: function ()
            {
                return this.currentPage === 1 ? 'none' : 'auto';
            },
            pointerEventNextPage: function ()
            {
                return this.currentPage === this.maxPages ? 'none' : 'auto';
            },
            orderedFacets: function () {
                for (var key in this.facets) {
                    if (this.facets.hasOwnProperty(key) && key.indexOf('@odata') === -1) {
                        var facet = this.facets[key];
                        if (facet) {
                            this.facets[key].sort((a, b) => {
                                if (!isNaN(a.value) && !isNaN(b.value)) return a.value - b.value;
                                var aParts = a.value.split(' ');
                                var bParts = b.value.split(' ');
                                if (!isNaN(aParts[0]) && !isNaN(bParts[0])) return aParts[0] - bParts[0];
                                if (!isNaN(aParts[1]) && !isNaN(bParts[1])) return aParts[1] - bParts[1];
                            });
                        }
                    }
                }
                return this.facets;
            },
            isProductItemsOutsideViewport: function () {
                if (this.productsBlockBounds !== null && this.maxPages === 1) {
                    const scroll = window.scrollY || window.pageYOffset;

                    const viewport = {
                        top: scroll,
                        bottom: scroll + window.innerHeight
                    };

                    const isInViewport = (this.productsBlockBounds.top >= viewport.top && this.productsBlockBounds.top <= viewport.bottom) ||
                        (this.productsBlockBounds.bottom >= viewport.top && this.productsBlockBounds.bottom <= viewport.bottom) ||
                        this.productsBlockBounds.bottom >= viewport.bottom;

                    return !isInViewport;
                } else {
                    return false;
                }
            }
        },
        methods: {
            setFacetValueOverrides: function (overrides)
            {
                var facet, foundFacetValue;
                for (var key in overrides)
                {
                    facet = this.facets[key];
                    if (facet)
                    {
                        _.forEach(overrides[key], function (value)
                        {
                            foundFacetValue = _.find(facet, function (x) { return x.value === value.key; });
                            if (foundFacetValue)
                            {
                                foundFacetValue['displayValue'] = value.value;
                            }
                        });
                    }
                }
            },
            setMinMaxValuesForRangeFacets: function ()
            {
                var facet;
                for (var key in this.rangeFacets)
                {
                    facet = this.facets[key];
                    if (facet)
                    {
                        var minvalue = _.minBy(facet, function (f) { return f.value; });
                        var maxvalue = _.maxBy(facet, function (f) { return f.value; });
                        if (minvalue)
                        {
                            if (isNaN(minvalue.value))
                            {
                                // Try to replace , with . (in case it's an NL number or a string)
                                minvalue.value = ('' + minvalue.value).replace(',', '.');
                            }
                            let actualMinValue = Math.floor(minvalue.value);
                            this.rangeFacets[key].value[0] = (this.rangeFacets[key].value[0] <= actualMinValue ? actualMinValue : this.rangeFacets[key].value[0]);
                            this.rangeFacets[key].min = Math.floor(minvalue.value);
                        }
                        if (maxvalue)
                        {
                            if (isNaN(maxvalue.value))
                            {
                                // Try to replace , with . (in case it's an NL number or a string)
                                maxvalue.value = ('' + maxvalue.value).replace(',', '.');
                            }
                            let actualMaxValue = Math.floor(maxvalue.value);
                            this.rangeFacets[key].value[1] = (this.rangeFacets[key].value[1] >= actualMaxValue ? actualMaxValue : this.rangeFacets[key].value[1]);
                            this.rangeFacets[key].max = Math.floor(maxvalue.value);
                        }
                    }
                }
            },
            rangeCallback: function (val, eventTargetId)
            {
                this.scrollToTopTargetId = eventTargetId;
                // re-enable scroll to top button
                this.isScrollToTopClicked = false;

                this.filtered = true;
                this.currentPage = 1;
                this.search()
                    .then((res) => {
                        this.setScrollPosition();
                        this.calculateProductsBlockBounds();
                    })
                    .catch((err) => {
                        this.hasError = true;
                        console.error(err);
                    });
            },
            facetClicked: function (val, event)
            {
                this.scrollToTopTargetId = event.target.id;
                // re-enable scroll to top button
                this.isScrollToTopClicked = false;

                this.filtered = true;
                return false;
            },
            resetFilters: function ()
            {
                this.checkedFacets = [];
                for (var key in this.rangeFacets)
                {
                    this.rangeFacets[key].value = [this.rangeFacets[key].min, this.rangeFacets[key].max];
                }
                this.filtered = false;
            },
            changeQuery: function ()
            {
                this.currentPage = 1;
                this.search();
            },
            hasSelectedASelectedFacetValue: function (facetKey)
            {
                return doHasASelectedFacetValue(facetKey, this.checkedFacets);
            },
            getHighlight: function (item, key)
            {
                if (item && item['@search.highlights'] && item['@search.highlights'][key] && item['@search.highlights'][key].length)
                {
                    var highlight = '';
                    if (item['@search.highlights'][key].length === 1) highlight = item['@search.highlights'][key][0];
                    else
                    {
                        for (var i = 0; i < item['@search.highlights'][key].length; i++)
                        {
                            highlight += item['@search.highlights'][key][i] + '..';
                        }
                        highlight = highlight.slice(0, -2);
                    }
                    return highlight;
                }
                return item[key];
            },
            createSearchRequest: function ()
            {
                var searchRequest = new azuresearch.AzureSearchRequest(this.searchSettings.searchRequest);
                var predefinedfilter = this.searchSettings.searchRequest.filter;
                var facetfilters = this.initialSearch ? null : GetFacetFilter(this.checkedFacets, this.facetSettings);
                var rangefilters = this.initialSearch ? null : GetRangeFilter(this.rangeFacets);
                var filter = ConcatFilters([predefinedfilter, facetfilters, rangefilters]);

                this.searchSettings.searchRequest.skip = searchRequest.skip = (this.currentPage - 1) * this.searchSettings.searchRequest.top;
                searchRequest.filter = filter;
                return searchRequest;
            },
            executeSearch: function (searchRequest)
            {
                return new Promise((resolve, reject) =>
                {
                    this.searchApi.search(searchRequest)
                    .then((response) =>
                    {
                        this.noResults = false;
                        if (response && response.data)
                        {
                            this.items = response.data.value;
                            this.facets = setFacets(this.facets, response.data['@search.facets'], this.initialSearch, this.checkedFacets);
                            this.count = response.data['@odata.count'];
                            this.noResults = this.count <= 0;

                            if (this.count > 0)
                            {
                                // Get and update the prices for all items from Kentico
                                this.getAndUpdatePricesFromSystem()
                                .then((priceResponse) =>
                                {
                                    if (this.initialSearch && this.facets && this.rangeFacets)
                                    {
                                        this.setMinMaxValuesForRangeFacets();
                                    }

                                    if (this.facetValueOverrides)
                                    {
                                        this.setFacetValueOverrides(this.facetValueOverrides);
                                    }

                                    if (this.initialSearch && !this.noResults)
                                    {
                                        console.log('initial search done...');
                                        this.initialSearch = false;
                                    }

                                    resolve(priceResponse);
                                })
                                .catch((priceError) =>
                                {
                                    resolve(priceError);
                                });
                            }
                            else resolve('NO_PRODUCTS');
                        }
                        else resolve('NO_DATA_IN_SEARCH_RESPONSE');
                    })
                    .catch((error) =>
                    {
                        this.hasError = true;
                        console.error(error);
                        reject(error);
                    });
                });
            },
            search: function (event)
            {
                return new Promise((resolve, reject) =>
                {
                    if (event) event.preventDefault();
                    this.updateHistory();
                    this.hasError = false;

                    let searchRequest = this.createSearchRequest();
                    if (this.initialSearch)
                    {
                        searchRequest.select = 'Apparaatsoort';
                        this.searchApi.search(searchRequest)
                        .then((response) =>
                        {
                            this.noResults = false;
                            if (response && response.data)
                            {
                                this.count = response.data['@odata.count'];
                                this.noResults = this.count <= 0;
                            }

                            if (this.tempRestorePage > this.maxPages) {
                                this.tempRestorePage = this.maxPages;
                            }

                            if (this.count > 0)
                            {
                                for (let i = 0; i < this.searchSettings.searchRequest.facets.length; i++)
                                {
                                    this.searchSettings.searchRequest.facets[i] += ',count:' + this.count;
                                }
                            }

                            searchRequest = this.createSearchRequest();
                            this.executeSearch(searchRequest)
                                .then((response) => {
                                    resolve(response);
                                    setTimeout(function () {
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }, this.scrollDelay);
                                })
                                .catch((error) => {
                                    reject(error);
                                });
                        })
                        .catch((error) =>
                        {
                            this.hasError = true;
                            console.error(error);
                            reject(error);
                        });
                    }
                    else
                    {
                        this.executeSearch(searchRequest)
                            .then((response) => {
                                setTimeout(function () {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, this.scrollDelay);
                                resolve(response);
                            })
                            .catch((error) => { reject(error); });
                    }
                });
            },
            previousPage: function () {
                this.currentPage--;
                this.search();
            },
            nextPage: function () {
                this.currentPage++;
                this.search();
            },
            goToPage: function (pageNumber) {
                if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= this.maxPages) {
                    this.currentPage = pageNumber;
                    this.search();
                }
            },
            getPaginatedUrlPreviousPage: function () {
                return this.getPaginatedUrlForPage(this.currentPage - 1);
            },
            getPaginatedUrlNextPage: function () {
                return this.getPaginatedUrlForPage(this.currentPage + 1);
            },
            getPaginatedUrlForPage: function (pageNumber) {
                const url = this.createQueryString(pageNumber);
                return url || window.location.pathname;
            },
            addToCart: function (item)
            {
                if (item !== undefined && item !== null)
                {
                    if (item.AdviesprijsWeergeven === true)
                    {
                        this.saveBeforeRedirect();
                        window.location.href = item.ProductURL;
                    }
                    else
                    {
                        let skuid = item.SKUID;
                        let axiosClient = axios.create({ baseURL: '/FRHandlers/' });
                        axiosClient.post('SchefferBasketHandler.ashx', { skuid: skuid })
                        .then((response) =>
                        {
                            if (response && response.data && response.data.success)
                            {
                                // The following situation: after addToCart, redirect to the shopping cart page, does not save previous facet/paging settings
                                // window.location.href = response.data.basketUrl;

                                // The following situation: stays on the page after addToCart, preserves facet/paging settings, triggers an animation
                                // Store some stuff in local storage to re-set it after postback
                                this.saveSettingsToLocalStorage();

                                // Push history to add action=add_cart parameter to the url (this triggers an animation).
                                // Then 'redirect-to-self'. The item stored in localstorage will make sure that the facet and paging settings are restored after postback
                                this.updateHistory(this.currentPage, true);
                                window.location.href = window.location.href;
                            }
                            else
                            {
                                console.log('failure');
                            }
                        })
                        .catch((exception) =>
                        {
                            console.error(exception);
                        });
                    }
                }
            },
            getAndUpdatePricesFromSystem: function ()
            {
                return new Promise((resolve, reject) =>
                {
                    if (this.items && this.items.length > 0)
                    {
                        let skuIds = this.items.map((v) => { return v.SKUID; });
                        let axiosClient = axios.create({ baseURL: '/FRHandlers/' });
                        axiosClient.post('SchefferPriceRequestHandler.ashx', { skuids: skuIds })
                        .then((response) =>
                        {
                            if (response && response.data)
                            {
                                if (this.items && this.items.length > 0)
                                {
                                    for (let i = 0; i < this.items.length; i++)
                                    {
                                        let itemResponseData = response.data[this.items[i].SKUID];
                                        if (itemResponseData)
                                        {
                                            let changedValue = this.items[i];
                                            changedValue.Price = itemResponseData.price;
                                            this.$set(this.items, i, changedValue);
                                        }
                                    }
                                    resolve('OK');
                                }
                                else resolve('NO_ITEMS');
                            }
                            else resolve('NO_RESPONSE_FROM_SERVICE');
                        })
                        .catch((error) =>
                        {
                            console.error(error);
                            reject(error);
                        });
                    }
                    else resolve(null);
                });
            },
            saveSettingsToLocalStorage: function()
            {
                let storeObject = { checkedFacets: this.checkedFacets, rangeFacets: this.rangeFacets, currentPage: this.currentPage };
                let storeJSON = JSON.stringify(storeObject);
                window.localStorage.setItem(this.localStorageName, storeJSON);
            },
            saveBeforeRedirect: function()
            {
                this.saveSettingsToLocalStorage();
                this.updateHistory(this.currentPage, false, true);
            },
            calculateProductsBlockBounds: function () {
                const scroll = window.scrollY || window.pageYOffset;
                const el = $('.block-products')[0];
                if (el) {
                    const boundsTop = el.getBoundingClientRect().top + scroll;

                    this.productsBlockBounds = {
                        top: boundsTop,
                        bottom: boundsTop + el.clientHeight
                    };
                }
            },
            setScrollPosition() {
                if (this.scrollToTopTargetId) {
                    const target = document.getElementById(this.scrollToTopTargetId);
                    const targetRect = target.getBoundingClientRect();
                    const bodyRect = document.body.getBoundingClientRect();
                    const offset = targetRect.top - bodyRect.top - window.innerHeight / 2;

                    // Set vertical position of scroll to top button
                    this.scrollToTopPos = {
                        'top': offset + 'px'
                    };
                    setTimeout(function () {
                        window.scrollTo({ top: offset, behavior: 'smooth' });
                    }, this.scrollDelay);
                }
            },
            scrollToTop() {
                this.isScrollToTopClicked = true;
                setTimeout(function () {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, this.scrollDelay);
            },
            updateHistory(page, itemAddedToCart, restoreFromStorage) {
                const url = this.createQueryString(page, itemAddedToCart, restoreFromStorage);
                if (itemAddedToCart) history.replaceState(null, null, url);
                else if (restoreFromStorage) history.replaceState(null, null, url);
                else if (this.restoreFromStorage) history.replaceState(null, null, url);
                else if (window.location.pathname === url) history.replaceState(null, null, url);
                else history.pushState(null, null, url);
            },
            createQueryString(page, itemAddedToCart, restoreFromStorage) {
                let queryParams = {};
                if (!page) page = this.currentPage;

                _.forEach(this.checkedFacets, function (x) {
                    const vals = x.split('|');
                    const key = vals[0];
                    const value = vals[1];
                    const existingFilter = queryParams[key];
                    if (existingFilter === undefined) {
                        queryParams[key] = value;
                    } else {
                        queryParams[key] += '|' + value;
                    }
                });

                for (const key in this.rangeFacets) {
                    const rangeFacet = this.rangeFacets[key];
                    if (getHasChanged(rangeFacet)) {
                        queryParams[key] = rangeFacet.value[0] + '|' + rangeFacet.value[1];
                    }
                }

                if (this.searchSettings.searchRequest.orderBy !== this.defaultSearchRequest.orderBy) queryParams['order'] = this.searchSettings.searchRequest.orderBy;
                if (page !== this.defaultSearchRequest.page) queryParams['page'] = page;
                if (parseInt(this.searchSettings.searchRequest.top) !== this.defaultSearchRequest.top) queryParams['top'] = this.searchSettings.searchRequest.top;
                if (itemAddedToCart === true) queryParams['action'] = 'add_cart';
                if (restoreFromStorage === true && !itemAddedToCart) queryParams['action'] = 'rfs';

                if (_.isEmpty(queryParams)) return window.location.pathname;
                let queryString = '?';
                _.forEach(queryParams, (value, key) => {
                    queryString += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
                });
                return queryString.slice(0, -1);
            },
            applyFiltersFromQueryString () {
                const urlSearchParams = new window.URLSearchParams(window.location.search);
                const queryCheckedFacets = [];
                for (const key of urlSearchParams.keys()) {
                    const keyVals = urlSearchParams.get(key);
                    if (key === 'page') {
                        this.tempRestorePage = this.searchSettings.gui.page;
                    }
                    if (_.has(this.rangeFacets, key)) {
                        const kv = keyVals.split('|');
                        if (kv.length === 2 && !isNaN(kv[0]) && !isNaN(kv[1])) this.rangeFacets[key].value = [kv[0], kv[1]];
                    } else {
                        _.forEach(this.facetSettings, function (facetSetting) {
                            if (facetSetting.key === key) {
                                _.forEach(keyVals.split('|'), function (x) {
                                    queryCheckedFacets.push(key + '|' + x);
                                });
                                return false;
                            }
                        });
                    }
                }
                this.restoreFromStorage = true;
                this.checkedFacets = queryCheckedFacets;
            }
        },
        created: function ()
        {
            // Set default data properties
            this.searchSettings = searchSettings;
            this.rangeFacets = rangeSliders;
            this.numRangeFacets = numRangeFacets;
            this.pageData = pageData;
            this.facetSettings = facetSettings;
            this.seoSettings = seoSettings;
            this.searchText = this.searchSettings.searchRequest.search;
            this.currentPage = this.searchSettings.gui.page;

            // Set default orderBy if not set
            if (!this.searchSettings.searchRequest.orderBy) this.searchSettings.searchRequest.orderBy = this.defaultSearchRequest.orderBy;

            // Set localStorage key if pageData is available
            if (this.pageData && this.pageData.uniqueId) this.localStorageName = this.pageData.uniqueId;

            // Init Azure Search API
            this.searchApi = new azuresearch.AzureSearchApi(this.searchSettings);

            // Extract facet value overrides (if any)
            _.forEach(this.searchSettings.facets, (facet) => {
                if (facet && facet.facetValueOverrides) {
                    // Set facet-value-overrides coming from the system
                    this.facetValueOverrides[facet.field] = facet.facetValueOverrides;

                    // Set one extra override, this handles the 'empty' field stuff
                    this.facetValueOverrides[facet.field].push({ key: '', value: '(onbekend)' });
                } else if (facet) {
                    // Set at least one override for all fields to handle 'empty' values
                    this.facetValueOverrides[facet.field] = [{ key: '', value: '(onbekend)' }];
                }
            });

            // Try get object from local storage, if it exist set it back up
            let rfsQueryParam = helper.getParameterByName('action');
            if (rfsQueryParam === 'rfs' || rfsQueryParam === 'add_cart') {
                let localStorageJSON = window.localStorage.getItem(this.localStorageName);
                if (localStorageJSON) {
                    // Parse to object, it is stored as JSON
                    let storedObject = JSON.parse(localStorageJSON);

                    // Set this to true to indicate we've done a postback due to a click on the add-to-cart button
                    this.restoreFromStorage = true;

                    // Re-set some variables from the object
                    this.tempRestorePage = storedObject.currentPage;
                    this.currentPage = storedObject.currentPage;
                    this.rangeFacets = storedObject.rangeFacets;
                    this.checkedFacets = storedObject.checkedFacets;

                    // Remove the item from storage
                    window.localStorage.removeItem(this.localStorageName);
                }
            } else { // If object from localstorage should not be applied, apply filters from query string
                this.applyFiltersFromQueryString();
            }

            if (this.searchSettings.gui.executeSearchOnLoad && !this.restoreFromStorage) {
                this.search()
                    .then((response) =>
                    {
                        this.ready = true;
                    })
                    .catch((error) =>
                    {
                        this.ready = true;
                        console.error(error);
                    });
            } else if (!this.restoreFromStorage) {
                this.ready = true;
                console.log('testink');
            }
        },
        mounted: function () {
            window.addEventListener('popstate', this.applyFiltersFromQueryString, false);
        },
        beforeDestroy: function () {
            window.removeEventListener('popstate', this.applyFiltersFromQueryString);
        }
    });
    return filtersApp;
}

function doHasASelectedFacetValue(facetKey, checkedFacets)
{
    if (checkedFacets !== null && checkedFacets.length > 0)
    {
        if (_.findIndex(checkedFacets, function (f) { return f.startsWith(facetKey); }) > -1)
        {
            return true;
        }
    }
    return false;
}

function setFacets(currentFacets, newFacets, initialSearch, checkedFacets) {
    // Guard checks
    if (initialSearch) return newFacets;

    // loop trough all facets
    for (var key in newFacets) {
        if (newFacets.hasOwnProperty(key) && key.indexOf('@odata') === -1) {
            // Get the items that are not in the new facet result and set the count to zero
            var difference = _.differenceBy(currentFacets[key], newFacets[key], 'value');
            if (difference && difference.length > 0) {
                _.forEach(difference, function (diff) {
                    if (!doHasASelectedFacetValue(key, checkedFacets)) diff.count = 0;
                });
            }

            // Get all items that still are in the new facet results and set them to their new count
            var intersect = _.intersectionBy(newFacets[key], currentFacets[key], 'value');
            if (intersect && intersect.length > 0) {
                _.forEach(intersect, function (inter) {
                    var item = _.find(currentFacets[key], function (x) { return x.value === inter.value; });
                    if (item) item.count = inter.count;
                });
            }
        }
    }
    return currentFacets;
}

function ConcatFilters(arFilters)
{
    if (arFilters)
    {
        var filters;
        for (var i = 0; i < arFilters.length; i++)
        {
            if (arFilters[i] && arFilters[i] !== '')
            {
                if (filters)
                {
                    filters = (filters + ' and ' + arFilters[i]);
                }
                else
                {
                    filters = arFilters[i];
                }
            }
        }
        return filters;
    }
    return null;
}

function getHasChanged(item)
{
    if (item.value && (Array.isArray(item.value)))
    {
        if (item.value[0] === item.min && item.value[1] === item.max)
        {
            return false;
        }
        else
        {
            return true;
        }
    }
}

function GetRangeFilter(items)
{
    if (items)
    {
        var filter = '';
        for (var key in items)
        {
            var haschanged = getHasChanged(items[key]);
            if (haschanged)
            {
                filter += '(' + key + ' ge ' + items[key].value[0] + ' and ' + key + ' le ' + items[key].value[1] + ') and ';
            }
        }

        if (filter.length)
        {
            filter = filter.slice(0, -5);
        }

        return filter;
    }
    return '';
}

function GetFacetFilter(items, facetSettings)
{
    var filter = '';
    var facets = _.map(items, function (f)
    {
        var kv = f.split('|');
        var facet = _.find(facetSettings, function (x)
        {
            return x.key === kv[0];
        });
        return { facetKey: kv[0], facetValue: kv[1], facetType: facet.value };
    });

    var groupedFacets = _.groupBy(facets, 'facetKey');
    _.forEach(groupedFacets, function (key)
    {
        var subFilter = '';
        _.forEach(key, function (facet)
        {
            if (facet.facetType === 'Collection')
            {
                subFilter += facet.facetKey + '/any(t: t eq \'' + facet.facetValue + '\') and ';
            }
            else if (facet.facetType === 'String')
            {
                subFilter += facet.facetKey + ' eq \'' + facet.facetValue + '\' or ';
            }
            else
            {
                subFilter += facet.facetKey + ' eq ' + facet.facetValue + ' or ';
            }
        });

        subFilter = `(${stripLastAndOr(subFilter)})`;
        filter += subFilter + ' and ';
    });

    return stripLastAndOr(filter);
}

function stripLastAndOr(filter)
{
    var tmp = filter + '';
    var reAnd = /and$/;
    var reOr = /or$/;

    tmp = tmp.trimEnd();
    tmp = tmp.replace(reAnd, '');
    tmp = tmp.replace(reOr, '');

    return tmp;
}

export default { init };



// WEBPACK FOOTER //
// ./CMS/scripts/modules/azureSearch/azureSearch.vm.js